import lazyImport from '../../../Utils/Loading/loadingHelpers'

export const Snackbar = lazyImport(() => import('@mui/material/Snackbar'), <div />)